import { useEffect, useRef, useState } from "react";
import subscribeToPayment from "../api/paymentUpdates.service";

export default function usePaymentUpdates(billingNo, initialData) {
  const initialRef = useRef(initialData);
  initialRef.current = initialData;
  const [state, setState] = useState({
    billingNo,
    data: initialData,
    connection: "connecting",
  });

  useEffect(() => {
    setState({ billingNo, data: initialRef.current, connection: "connecting" });
    if (!billingNo) return undefined;
    return subscribeToPayment(
      billingNo,
      (data) => setState((previous) => ({ ...previous, data })),
      (connection) => setState((previous) => ({ ...previous, connection })),
    );
  }, [billingNo]);

  return state.billingNo === billingNo
    ? state
    : { data: initialData, connection: "connecting" };
}
